var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9856 1.80469L1.37891 18.3163",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9308 5.35156C18.5827 5.89644 19.0011 6.72348 19.0011 7.65755V13.3009C19.0011 15.568 17.1621 17.4069 14.8951 17.4069H6.52734",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86814 16.7396C1.73947 16.0099 1 14.745 1 13.305V7.66166C1 5.97838 2.37192 4.60647 4.06492 4.60647C4.55141 4.58701 5.01845 4.38268 5.35899 4.02267C5.53413 3.81835 5.83576 3.32212 6.09846 2.84536C6.49739 2.13508 7.23686 1.6875 8.0542 1.6875H11.9656C12.7926 1.6875 13.5418 2.14481 13.931 2.87455C14.184 3.34158 14.4662 3.82808 14.6413 4.02267C14.6802 4.07132 14.7289 4.11024 14.7775 4.13943",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25653 12.0966C7.03274 11.6685 6.90625 11.1723 6.90625 10.6566C6.90625 8.9539 8.2879 7.5625 10.0004 7.5625C10.4577 7.5625 10.8858 7.6598 11.275 7.84467",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0908 10.6562C13.0908 12.3643 11.7061 13.749 9.99805 13.749",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoPhoto);
export default __webpack_public_path__ + "static/media/ic_no_photo.45358790a12db525d305634bb6c5394b.svg";
export { ForwardRef as ReactComponent };